import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { Popover } from 'antd';
import SelectSearch from 'react-select-search';
import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import { getCompanyTextColor } from '../../../utils';
import { renderTag } from '../../../utils/lookahead-common';
import { trackingEvent } from '../../../analytics';
import { AMPLITUDE_SERVICE } from '../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../analytics/utils';
import { TagIconExt } from '../../../icons';
import { ReactComponent as TagSolidIcon } from '../../../assets/img/icons/icon--tag-solid.svg';
import addTagIcon from '../../../assets/img/gantt/add-tag.png';
import removeIconNew from '../../../assets/img/gantt/X.png';

const tagsCol = (gantt, t, fieldNoPermission, triggerSetter, cursorCustomStyle) => ({
  name: 'tags',
  label: 'Tags',
  data_type: 'array/images',
  visible: true,
  hide: !isColumnVisibleByDefault('tags'),
  span: 2,
  offset: 0,
  align: 'center',
  mode: 'multiple',
  from_values: 'toSelectTags',
  el_to_extract_from: 'id',
  el_to_label_from: ['name'],
  img_from: 'image',
  width: 125,
  groupable: false,
  groupable_switch: ['A → Z', 'Z → A'],
  orderable: false,
  orderable_switch: ['A → Z', 'Z → A'],
  filterable: true,
  resize: true,
  template: (task) => {
    const currentGantt = window.to_use_react_gantt;
    if (!currentGantt) {
      return '';
    }

    let isOdd = false;
    if (currentGantt.oddColsConfig) {
      isOdd = currentGantt.oddColsConfig.tags;
    }

    const colClassName = isOdd ? 'odd-col' : 'non-odd-col';
    const { tags } = task;

    const tagsRender = tags.map((tag) => {
      const {
        description: tagDescriptionColor,
        name: tagName,
        id: tagId
      } = tag;

      const tagIconRender = (
        <div
          className="tag-column-template__icon"
          style={{ color: tagDescriptionColor }}>
          <TagSolidIcon />
        </div>
      );

      const tagNameRender = (
        <p className="tag-column-template__text">{tagName}</p>
      );

      return (
        <div key={tagId} className={'tag-column-template__item '}>
          {tagIconRender}
          {tagNameRender}
        </div>
      );
    });

    const tagTemplate = (
      <div className={`tag-column-template ${colClassName}`}>
        {tagsRender}
      </div>
    );

    const tagTemplateString =
      ReactDOMServer.renderToStaticMarkup(tagTemplate);

    return tagTemplateString;
  },
  onrender: (task, node) => {
    const currentGantt = window.to_use_react_gantt;
    if (!currentGantt) return null; // Return null if gantt is not available
    let isOdd = false;
    if (currentGantt.oddColsConfig) {
      isOdd = currentGantt.oddColsConfig.tags;
    }
    const column = 'tags';
    const el_to_extract_from = 'id';
    const el_to_label_from = 'name';
    const from_values = currentGantt.toSelectTags;
    if (!from_values) return null; // Return null if from_values is not available

    const friends = [];
    const selected = [];
    const dictionary = {};

    task[column].map((res) => {
      const value = res[el_to_extract_from] + '-';
      selected.push(value);
      return null;
    });
    let popRef = null;
    from_values.map((tag) => {
      const value = tag[el_to_extract_from] + '-';
      friends.push({
        name: tag[el_to_label_from],
        value,
        object: tag
      });
      dictionary[value] = tag;
      return null;
    });

    const customOverlayClassName = currentGantt.toSelectTags.length
      ? 'container-image-custom custom-proplanner-tag'
      : 'container-image-custom custom-proplanner-tag-init';

    return (
      <div
        className={`custom-multi-select-pop react-dhtmlx ${isOdd ? 'odd-col' : 'non-odd-col'}`}
        style={{
          width: column.width ? column.width : '100%',
          height: '100%',
          marginTop: 0,
          border: 0,
          ...cursorCustomStyle
        }}>
        <Popover
          ref={(r) => {
            popRef = r;
          }}
          placement="bottom"
          overlayClassName={customOverlayClassName}
          className="popoverPriority custom-tags-proplanner"
          content={
            <>
              <SelectSearch
                renderGroupHeader={(name) => (
                  <div
                    className="add-subcontract-inline custom-create-tag-to-select-checkbox"
                    onClick={() => {
                      if (popRef) {
                        popRef.tooltip.setState({ visible: false });
                        window.to_use_react_gantt.render();
                      }
                      currentGantt.toHardAssignTag = task.id;
                      currentGantt.setVisibleFormTags(true);
                    }}>
                    {t('create_tag_label')}
                  </div>
                )}
                className="select-search select-search--multiple"
                options={[
                  {
                    type: 'group',
                    name: 'Group name',
                    items: friends.length
                      ? friends
                      : [
                          {
                            name: 'NONE_TAG_EXIST',
                            value: 'NONE_TAG_EXIST'
                          }
                        ]
                  }
                ]}
                value={selected}
                renderOption={renderTag}
                onChange={(val) => {
                  currentGantt.ext.undo.saveState(task.id, 'task');
                  task[column] = [];
                  trackingEvent(
                    'activity_tag_entry',
                    {
                      ...getBasicAmplitudEventProperties(),
                      activity_name: task?.text,
                      activity_id: task?.id,
                      activity_index: task?.correlative_id
                    },
                    AMPLITUDE_SERVICE
                  );
                  val.map((op) => {
                    task[column].push(dictionary[op]);
                    return null;
                  });

                  if (
                    window.to_use_react_gantt.visualizationColorActive ===
                    'tags'
                  ) {
                    window.to_use_react_gantt.defineColorByTags(task, true);
                  } else {
                    window.to_use_react_gantt.render();
                  }
                }}
                multiple
                search
                placeholder={t('search_tags_placeholder')}
              />
              <div
                style={{
                  alignContent: 'center',
                  textAlign: 'center',
                  position: 'relative',
                  height: 25
                }}
                className="add-subcontract-inline"
                onClick={() => {
                  task[column] = [];
                  if (popRef) {
                    popRef.tooltip.setState({ visible: false });
                    if (
                      window.to_use_react_gantt.visualizationColorActive ===
                      'tags'
                    ) {
                      window.to_use_react_gantt.defineColorByTags(
                        task,
                        true
                      );
                    } else {
                      window.to_use_react_gantt.render();
                    }
                  }
                }}>
                <span
                  style={{
                    position: 'relative',
                    left: -7
                  }}>
                  <img width="10" src={removeIconNew} alt="remove icon" />
                </span>
                <span
                  style={{
                    color: '#121212',
                    fontSize: 12
                  }}>
                  {t('remove_tag_label')}
                </span>
              </div>
            </>
          }
          trigger={triggerSetter}>
          <div style={{ height: '100%' }}>
            {task[column].length ? (
              task[column].map((tag, index) => {
                const { description, name } = tag;
                const textColor = getCompanyTextColor(description);
                return (
                  <div key={`${index}-tag-proplanner`}>
                    <div
                      key={`${index}-tag-proplanner`}
                      className="tag-proplanner"
                      style={{
                        width: 70,
                        height: 17,
                        backgroundColor: description,
                        marginLeft: 16,
                        color: textColor
                      }}></div>
                    <div
                      className="tag-proplanner-content"
                      style={{
                        position: 'relative',
                        top: -11,
                        left: '19%',
                        display: 'inline-flex',
                        float: 'left'
                      }}>
                      <span
                        style={{
                          width: 5,
                          height: 5,
                          borderRadius: '50%',
                          backgroundColor: description,
                          border: `1px solid ${textColor}`,
                          position: 'relative',
                          zIndex: 1
                        }}></span>
                      <span
                        title={name}
                        className="cut-text-and-dot pdf-fix-text"
                        style={{
                          position: 'relative',
                          top: -12,
                          maxWidth: 60,
                          left: 4,
                          zIndex: 1,
                          color: textColor
                        }}>
                        {name}
                      </span>
                    </div>

                    {/* This div is for the pfd content */}
                    <div className="tag-class-span">
                      <TagIconExt
                        color={description}
                        className="tag-class-pdf"
                      />
                      {name}
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                className="opacity-hover-style"
                style={{ width: '100%', height: '100%' }}>
                <span
                  className="add-responsable-new"
                  style={cursorCustomStyle}>
                  <img width="100" src={addTagIcon} alt="add tag" />
                </span>
              </div>
            )}
          </div>
        </Popover>
      </div>
    );
  }
});

export default tagsCol; 